import React from 'react'
import {papers, groupBibEntries} from '../utils/bibliography'

import locales from '../utils/strings'
import styles from '../templates/basic.module.less'
import Layout from "../components/layout";

const entryGroups = groupBibEntries(papers)

const PublicationsPage = ({ location, pathContext }) => {
  const {lang} = pathContext

  if (!locales[lang]) {
    throw new Error(`Unknown language: ${lang}.`)
  }

  const strings = locales[lang].publications

  return <Layout location={location}>
    <div>
      <h1 className={styles.title}>{strings.title}</h1>
      {
        entryGroups.map(([year, subgroups]) => (
          <div key={year}>
            <h2>{strings.yearHeading.replace('{}', year)}</h2>
            {
              subgroups.map(([myType, entries]) => <div key={myType}>
                <h3>{strings.types[myType] || myType}</h3>
                <ul>
                  { entries.map(entry => <PublicationEntry entry={entry} key={entry.id} />) }
                </ul>
              </div>)
            }
          </div>
        ))
      }
    </div>
  </Layout>
}

const PublicationEntry = ({ entry }) => {
  const lang = entry.memo.split('-')[2] // 'e' | 'j'

  const authors = entry.author.split(' and ')
  const sep = lang === 'j' ? '，' : ', '
  const publicationName = entry.booktitle || entry.journal
  const publicationLink = entry.link || entry.doi
  const parts = [
    lang === 'j' ? authors.join('，') : authors.join(', '),
    publicationLink
      ? <a href={publicationLink}><b>{entry.title}</b></a>
      : <b>{entry.title}</b>,
  ]

  if (publicationName) {
    parts.push(lang === 'j' ? publicationName : <i>{publicationName}</i>)
  }

  if (entry.volume) {
    parts.push(`Vol.${entry.volume}`)
  }

  if (entry.number) {
    parts.push(`No.${entry.number}`)
  }

  if (entry.pages && entry.pages !== '0--0' && entry.pages !== '1--1') {
    parts.push(`pp. ${entry.pages}`)
  }

  if (entry.address) {
    parts.push(entry.address)
  }

  const [year, month] = entry.yearMonth
  parts.push(lang === 'j' ? `${year}年${month}月` : `${entry.month} ${entry.year}`)

  return <li>
    {parts.map((part, i) => <React.Fragment key={i}>
      {i > 0 ? sep : ''}
      {part}
    </React.Fragment>)}
    .
  </li>
}

export default PublicationsPage
